"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStyleToEmotionObject;

var _useWebChatUIContext = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStyleToEmotionObject() {
  return (0, _useWebChatUIContext.default)().styleToEmotionObject;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTdHlsZVRvRW1vdGlvbk9iamVjdCIsInVzZVdlYkNoYXRVSUNvbnRleHQiLCJzdHlsZVRvRW1vdGlvbk9iamVjdCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL2ludGVybmFsL3VzZVN0eWxlVG9FbW90aW9uT2JqZWN0LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVN0eWxlVG9FbW90aW9uT2JqZWN0KCkge1xuICByZXR1cm4gdXNlV2ViQ2hhdFVJQ29udGV4dCgpLnN0eWxlVG9FbW90aW9uT2JqZWN0O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSx1QkFBVCxHQUFtQztFQUNoRCxPQUFPLElBQUFDLDRCQUFBLElBQXNCQyxvQkFBN0I7QUFDRCJ9